export default function Footer() {
  return (
    <footer className="footer text-center">
      All Rights Reserved by Da-Rose Ikonne Hospital
    </footer>
  );
}
